<template>
  <el-table
    ref="multipleTable"
    :data="tableData"
    tooltip-effect="light"
    style="width: 100%"
    @selection-change="handleSelectionChange"
    >
    <el-table-column v-if="isDia" type="selection" width="55">
    </el-table-column>
    <el-table-column label="组ID" prop="groupId" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column label="组名称" prop="name" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column label="组管理员" prop="groupAdmin" :show-overflow-tooltip="true">
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    isDia: {
      type: Boolean,
      default: true
    },
    selectGroup: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit("changeSelect", val)
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          let item = this.tableData.find(item => item.id === row.id)
          this.$refs.multipleTable.toggleRowSelection(item)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    }
  }
}
</script>
